import { NoLicenseTemplate } from "./no-license.template";

export const NoLicense = () => {
	return <NoLicenseTemplate />;
};
